// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "6f02781-dirty",
    "hash": "6f02781",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "6f02781-dirty",
    "semverString": null,
    "version": "2.0.16"
};
/* tslint:enable */
